import { Module } from "vuex";
import { IRequestState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const request: Module<IRequestState, any> = {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions,
};

export { request };
